// Collections
export const CORONATION_COLLECTION_LONDON = 'ccmxcwwf';
export const GTFO_EAT_COLLECTION_SF = 'ccmxcxft';
export const GTFO_EAT_COLLECTION_LA = 'ccmxcxfc';
export const GTFO_EAT_COLLECTION_LONDON = 'ccmxcxdm';
export const GTFO_EAT_COLLECTION_CHI = 'ccmxcxcx';
export const GTFO_EAT_COLLECTION_DC = 'ccmxcxcf';
export const GTFO_EAT_COLLECTION_NYC = 'ccmxcxbq';
export const GTFO_DATE_COLLECTION_CHI = 'ccmxcxzq';
export const GTFO_DATE_COLLECTION_DC = 'ccmxcybf';
export const GTFO_DATE_COLLECTION_LA = 'ccmxcxyh';
export const GTFO_DATE_COLLECTION_LONDON = 'ccmxcybx';
export const GTFO_DATE_COLLECTION_NYC = 'ccmxcxxt';
export const GTFO_DATE_COLLECTION_SF = 'ccmxcxyz';
export const GTFO_DATE_COLLECTION_US = 'ccmxcxxc';
export const PAIGE_HANNAH_COLLECTION_US = 'ccmxcyhf';
export const NYE_COLLECTION_2023_NYC = 'cwtgckw';
export const NYE_COLLECTION_2023_CHI = 'cwtgcwp';
export const NYE_COLLECTION_2023_LA = 'cwtgcpk';
export const NYE_COLLECTION_2023_DC = 'cwtgcrb';
export const NYE_COLLECTION_2023_SF = 'cwtgmcb';
export const NYE_COLLECTION_2023_LDN = 'cwtppzk';
export const NYE_COLLECTION_2023_AT = 'cwtgcxk';
export const NYE_COLLECTION_2023_DL = 'ccmxcwfm';
export const NYE_COLLECTION_2023_HO = 'ccmxcwgc';
export const NYE_COLLECTION_2023_MI = 'cwtgcwb';
export const NYE_COLLECTION_2023_OL = 'ccmxcwdx';
export const COWBOYCORE_COLLECTION_LA = 'ccmxcyrf';
export const COWBOYCORE_COLLECTION_DL = 'ccmxcytm';
export const COWBOYCORE_COLLECTION_HT = 'ccmxcyrx';
export const COWBOYCORE_COLLECTION_SF = 'ccmxcyzx';
export const MATCHMAKER_MARIA_NYC = 'ccmxczbm';
export const DO_GOOD_VOLUNTEERING = 'ccmxczcc';
export const JULY_FOURTH_US = 'ccmxcxmm';
export const JULY_FOURTH_NYC = 'ccmxcxgz';
export const JULY_FOURTH_DC = 'ccmxcxgh';
export const JULY_FOURTH_LA = 'ccmxcxhq';
export const JULY_FOURTH_SF = 'ccmxcxkf';
export const JULY_FOURTH_CHI = 'ccmxcxkx';
export const SUMMER_FESTIVALS_LA = 'ccmxcwzz';
export const END_OF_SUMMER_CHI = 'ccmxcxqh';
export const END_OF_SUMMER_DC = 'ccmxcxrq';
export const END_OF_SUMMER_NYC = 'ccmxcxqz';
export const END_OF_SUMMER_LONDON = 'ccmxcxtf';
export const EATER_NYC = 'cgrkyrw';
export const PRIDE_DC_2023 = 'ccmxcwzh';
export const PRIDE_CHICAGO_2023 = 'ccmxcwyt';
export const PRIDE_LA_2023 = 'ccmxcwyc';
export const VALENTINES_DAY_LONDON = 'ccmxcwmf';
export const VALENTINES_DAY_NYC = 'ccmxcwhz';
export const VALENTINES_DAY_CHI = 'ccmxcwkq';
export const VALENTINES_DAY_LA = 'ccmxcwpm';
export const VALENTINES_DAY_SF = 'ccmxcykm';
export const VALENTINES_DAY_DC = 'ccmxcymc';
export const VALENTINES_DAY_NYC2 = 'ccmxcymt';
export const WORLD_SURF_LEAGUE = 'ccmxcyhx';
export const HOLIDAY_SEASON_COLLECTION_VIRTUAL = 'cwycdzg';
export const HOLIDAY_SEASON_COLLECTION_NYC = 'ccmxctth';
export const HOLIDAY_SEASON_COLLECTION_LA = 'ccmxcttz';
export const HOLIDAY_SEASON_COLLECTION_LONDON = 'ccmxctym';
export const HOLIDAY_SEASON_COLLECTION_CHI = 'ccmxctxf';
export const HOLIDAY_SEASON_COLLECTION_SF = 'ccmxctxx';
export const HOLIDAY_SEASON_COLLECTION_DC = 'ccmxctwq';
export const HALLOWEEN_COLLECTION_VIRTUAL = 'cwxtcxp';
export const HALLOWEEN_COLLECTION_NYC = 'cgrkdxb';
export const HALLOWEEN_COLLECTION_LA = 'cgrkwgr';
export const HALLOWEEN_COLLECTION_CHI = 'cgrkwrr';
export const HALLOWEEN_COLLECTION_LONDON = 'ccmxctrt';
export const SOCIAL_CONNECTION = 'cchkwffq';
export const AUSTRALIAS_FIRST_PEOPLES = 'ccfzdxzh';
export const EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE = 'cwwyfmk';
export const NEW_YORK_EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE =
    'cchkwfgf';
export const SAN_FRANCISCO_EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE =
    'cchkwfgx';
export const LONDON_EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE =
    'cchkwfhm';
export const EVENTS_TO_ATTEND_WITHOUT_STEPPING_FOOT_OUTSIDE = 'cwwqhpk';
export const MUSIC_EVENTS_TO_KEEP_YOU_DANCING_AT_HOME = 'cwwrkfd';
export const WELLNESS_EVENTS_TO_KEEP_YOU_GROUNDED = 'cwwrcfp';
export const EVENTS_FOR_KIDS_WHILE_PARENTS_WORK_FROM_HOME = 'cwwrdbd';
export const ARTS_AND_CRAFTS_EVENTS_TO_BING_COLOR_INTO_YOUR_LIFE = 'cwwrkgg';
export const FOOD_AND_DRINKS_EVENTS_TO_FEAST_ON_WHILE_RESTAURANTS_AND_BARS_ARE_CLOSED =
    'cwwrpkg';
export const FITNESS_CLASSES_FOR_BREAKING_A_SWEAT_AT_HOME = 'cwwttyy';
export const EVENTS_FOR_BUSINESS_SKILLS_AND_NETWORKING_FROM_HOME = 'cwwtbpp';
export const CONNECT_THROUGH_ONLINE_EVENTS = 'cwwqztp';
export const EDUCATE_YOURSELF_ONLINE_RACIAL_EQUITY_WORKSHOPS = 'cwwzzcp';
export const ENTERTAIMENT_TONIGHT = 'cwxbtcw';
export const TAKE_CARE_OF_YOURSELF_AND_YOUR_COMMUNITY = 'cwxmbwp';
export const BLACK_HISTORY_AND_BEYOND = 'cwxqphr';
export const TRICKS_AND_TREATS_VIRTUAL_HALLOWEEN_EVENTS_FOR_ALL_AGES =
    'cwxtcxp';
export const SOCIALISING_SAFELY_PHYSICALLY_DISTANT_EVENTS_IN_THE_UK = 'cwxtmmy';
export const BEST_UK_AND_IRELAND_EVENTS_URL = 'cwxygxg';
export const ONLINE_THANKSGIVING_COOKING = 'cwxzcyw';
export const NATIVE_AMERICAN_HERITAGE = 'cwxztxr';
export const FESTIVE_EVENTS_UK_AND_IE = 'cwxzxyd';
export const BEST_EVENTS_TO_EXPERIENCE_IN_BRISBANE = 'cwxwfwy';
export const BEST_EVENTS_TO_EXPERIENCE_IN_PERTH = 'cwxwftp';
export const BEST_EVENTS_TO_EXPERIENCE_IN_AUCKLAND = 'cwxcbck';
export const HOLIDAY_EVENTS_CHRISTMAS_HANUKKAH_KWANZAA = 'cwycdzg';
export const VIRTUAL_NEW_YEAR_EVENTS_2020 = 'cwychcy';
export const FEEL_THE_LOVE_UK_IE = 'cwykqtd';
export const VIRTUAL_VALENTINE_US_CA = 'cwykwry';
export const BLACK_HISTORY_MONTH_US_CA = 'cwyhygw';
export const WOMENS_DAY_US_UK_IE = 'cwyrywd';
export const BEST_EVENTS_TO_EXPERIENCE_IN_MELBOURNE = 'cwyczbd';
export const BEST_EVENTS_TO_EXPERIENCE_IN_SYDNEY = 'cwybhwr';
export const EVENT_PLANNING_WEBINARS_US_CA_UK_IE_AU = 'cwywhzb';
export const UK_FESTIVALS_2021 = 'cyfghwd';
export const STOP_ASIAN_HATE_US = 'ccbddmmg';
export const PARK_UP_UK = 'cwxctzw';
export const ALL_YOUR_FAVES_UK_IE = 'cgtyfwr';
export const VIRTUAL_EARTH_DAY_US_CA_UK_IE_AU_NZ = 'ccbfwgyd';
export const HALLOWEEN_UK_IE = 'ctqrtgk';
export const US_INTL_WOMENS_DAY = 'cwyrywd';
export const US_ST_PATRICKS_DAY = 'ccfzwfbz';
export const SYDNEY_JUNE13_COLLECTION = 'cchkwfkt';
export const MELBOURNE_JUNE13_COLLECTION = 'cchkwfkc';
export const REMIXER_NYC = 'cckfprbc';
export const DC_ST_PATRICKS_DAY = 'ccmxcypz';
export const BOSTON_ST_PATRICKS_DAY = 'ccmxcyqq';
export const NEW_YORK_ST_PATRICKS_DAY = 'ccmxcwqc';
export const CHICAGO_ST_PATRICKS_DAY = 'ccmxcwrz';
export const LA_ST_PATRICKS_DAY = 'ccmxcwrh';
export const SF_ST_PATRICKS_DAY = 'ccmxcwqt';
export const LONDON_ST_PATRICKS_DAY = 'ccmxcwtq';
export const MENTAL_HEALTH_ACTION_DAY = 'ccmxcwwx';
export const NY_FASHION_WEEK = 'ccmxcxtx';
export const HALLOWEEN_PARTIES_IN_WASHINGTON = 'cgrkwmk';
export const HALLOWEEN_PARTIES_IN_SAN_FRANCISCO = 'cgrkyyw';
export const BUMBLE_DATE_IDEAS_CHICAGO = 'ccmxcydc';
export const BUMBLE_DATE_IDEAS_NYC = 'ccmxcycm';
export const BUMBLE_DATE_IDEAS_LONDON = 'ccmxcydt';
// Priority Collections
export const LOS_ANGELES_EVENT_CALENDAR_US = 'cfxrryy';
export const SAN_FRANCISCO_EVENT_CALENDAR_US = 'cfxrztd';
export const LONDON_EVENT_CALENDAR_UK = 'cgrrypy';
export const NEW_YORK_CITY_EVENT_CALENDAR = 'cfxwcyg';
export const CHICAGO_CITY_EVENT_CALENDAR = 'cfyzxpy';
export const WASHINGTON_DC_CITY_EVENT_CALENDAR = 'cfxtptk';
export const MUSIC_FESTIVAL_CALENDAR = 'cwwhpcd'; // This one is shown on LA, SF, NY, Chicago and DC, and should be on the second spot of the carousel

// QA collections
export const QA_TEST_MADE_FOR_NYC_FOOD_LOVERS = 'cfcpq';
export const QA_TEST_MOCKED_COLLECTION_FOR_TESTING = 'abc';
export const QA_TEST_MOCKED_COLLECTION_FOR_TESTING2 = 'abcd';
export const QA_TEST_MISMATCHED_DATA = 'chkyywh';
